import FilterCheckboxChip from './FilterCheckboxChip';
import FilterSelect from '../Input/FilterSelect';
import { formatVolume } from 'utils/helpers';
import { handleMixpanelEvent } from '../FilterAccordion/FilterAccordionItem';
import styled from 'styled-components';
import { useFetchMostPopularPopIndexAffinityRoots } from 'utils/hooks';
import { withMixpanelChange } from 'utils/app';

const Wrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space_6}px;
`;

const PopularityIndexAffinityFilterChipsUntracked = ({
    menus,
    filtersSansHealthStats,
    filters,
    setFilter,
    setFilters,
    filterNames,
    mixpanelMeta,
    getOnChange,
    appliedFilters,
    onChange,
    queryData,
    ...props
}) => {
    const { data, NoOptionsMessage, ...restQuery } =
        useFetchMostPopularPopIndexAffinityRoots(queryData);
    const resetMenuFilters = () => {
        const popIndexParentName = (filters.popIndexParentName || []).filter(
            ({ value }) => data?.map(({ value }) => value).includes(value),
        );
        const nextFilters = {};

        if (popIndexParentName.length) {
            nextFilters.popIndexParentName = popIndexParentName;
        }

        setFilters(nextFilters);
    };
    return (
        <Wrapper {...props}>
            {menus && menus.length ? (
                <span id="data-table-filter-select">
                    <FilterSelect
                        filters={filtersSansHealthStats}
                        setFilter={setFilter}
                        resetFilters={resetMenuFilters}
                        mixpanelMeta={mixpanelMeta}
                        menus={menus}
                        getOnChange={getOnChange}
                        menuAlign="left"
                        queryData={queryData}
                        appliedFilterChipCount={data?.reduce(
                            (acc, { value }) =>
                                acc + (appliedFilters?.includes(value) ? 1 : 0),
                            0,
                        )}
                    />
                </span>
            ) : null}
            {data && data.length ? (
                data.map((option) => {
                    const { label, value, volume } = option;
                    const checked =
                        !!appliedFilters && appliedFilters.includes(value);

                    return (
                        <FilterCheckboxChip
                            checked={checked}
                            onChange={() =>
                                onChange({
                                    action: checked
                                        ? 'remove-value'
                                        : 'select-option',
                                    option,
                                })
                            }
                            preserveIconSpace={false}
                            key={label}
                        >
                            <span>
                                {label}{' '}
                                <span
                                    css={`
                                        font-weight: 500;
                                        margin-left: 0.5rem;
                                        color: ${({ theme }) => theme.gray_600};
                                        text-transform: uppercase;
                                    `}
                                >
                                    {formatVolume(volume)}
                                </span>
                            </span>
                        </FilterCheckboxChip>
                    );
                })
            ) : (
                <span>
                    <NoOptionsMessage {...restQuery} />
                </span>
            )}
        </Wrapper>
    );
};

const PopularityIndexAffinityFilterChipsWithMixpanel = withMixpanelChange(
    PopularityIndexAffinityFilterChipsUntracked,
    'PopularityIndexAffinityFilterChips',
);

export const PopularityIndexAffinityFilterChips = ({
    handleMixpanelEvent: handleMixpanelEventProp = handleMixpanelEvent,
    mixpanelContext = 'PopIndexGroupFilterSelect',
    ...props
}) => {
    return (
        <PopularityIndexAffinityFilterChipsWithMixpanel
            handleMixpanelEvent={handleMixpanelEventProp}
            mixpanelContext={mixpanelContext}
            {...props}
        />
    );
};

export default PopularityIndexAffinityFilterChips;
